export default {"src":"/_next/static/media/white-virtual-tour-genric-icon.075c377f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};